import React, { useEffect, useRef, useState } from 'react'
import { baixarMidiaWhatsApp } from '../services/whatsappCrmApi'

const cacheBlobs = new Map()

const WhatsAppAudioPlayer = ({ mensagem, userId, outgoing = false }) => {
  const audioRef = useRef(null)
  const [src, setSrc] = useState(() => cacheBlobs.get(mensagem.id) || '')
  const [carregando, setCarregando] = useState(false)
  const [erro, setErro] = useState(null)

  useEffect(() => {
    if (!src || !audioRef.current) return
    audioRef.current.play().catch(() => {})
  }, [src])

  const carregarAudio = async () => {
    if (src || carregando || !userId) return
    setCarregando(true)
    setErro(null)
    const res = await baixarMidiaWhatsApp({ usuarioId: userId, mensagemId: mensagem.id })
    setCarregando(false)
    if (!res.success) {
      setErro(res.error)
      return
    }
    const url = URL.createObjectURL(res.blob)
    cacheBlobs.set(mensagem.id, url)
    setSrc(url)
  }

  return (
    <div className={`wa-audio ${outgoing ? 'wa-audio--out' : ''}`}>
      {src ? (
        <audio ref={audioRef} className="wa-audio-controls" src={src} controls preload="metadata" />
      ) : (
        <button
          type="button"
          className="wa-audio-play"
          onClick={carregarAudio}
          disabled={carregando || !userId}
        >
          <i className={`bi ${carregando ? 'bi-arrow-repeat' : 'bi-play-fill'}`} />
          <span>{carregando ? 'Carregando...' : 'Ouvir áudio'}</span>
        </button>
      )}
      {erro && <span className="wa-audio-erro">{erro}</span>}
    </div>
  )
}

export default WhatsAppAudioPlayer
